import { Box, ComboBox, Stack } from '@ads-core/components';
import { Filter } from 'src/types';

import { useTrackingContext } from '@liander/context';

import { slugify, baseQueryParams } from 'src/utils';
import { useSetParamsToRoute } from '../../hooks/useSetParamsToRoute';
import { getProjectOverviewUrlParams } from './utils/getProjectOverviewUrlParams';

export const queryParams = {
  ...baseQueryParams,
};

type FiltersProps = {
  regionsFilterOptions: Filter[];
  cityFilterOptions: string[];
  currentFilterRegion?: string;
  currentFilterCity?: string;
};

export const Filters = (props: FiltersProps) => {
  const { trackCustomWizard } = useTrackingContext();
  const { setParamsToRoute } = useSetParamsToRoute();
  const { regionsFilterOptions, cityFilterOptions, currentFilterRegion, currentFilterCity } = props;

  return (
    <Stack direction="row" gap={4}>
      {regionsFilterOptions.length > 1 ? (
        <Box paddingBottom={10} width={{ md: '33%' }}>
          <ComboBox
            placeholder="Kies een regio"
            label="Filter op regio"
            options={[
              { label: 'Toon alle', value: '' },

              ...regionsFilterOptions.map((region) => {
                return {
                  label: region.displayName,
                  value: region.id,
                };
              }),
            ]}
            value={currentFilterRegion}
            handleOnChange={(option) => {
              const urlParams = getProjectOverviewUrlParams({
                region: option.value,
                regionFilterOptions: regionsFilterOptions,
              });

              trackCustomWizard({
                wizardName: 'Filter',
                wizardStep: 1,
                actionType: 'select_filter',
                action: 'submit',
                actionDetail: 'Filter op regio',
                wizardOutput: option?.label,
              });

              setParamsToRoute(urlParams);
            }}
          />
        </Box>
      ) : null}
      {cityFilterOptions.length > 1 ? (
        <Box paddingBottom={10} width={{ md: '33%' }}>
          <ComboBox
            placeholder="Kies een plaats"
            label="Filter op plaats"
            options={[
              { label: 'Toon alle', value: '' },
              ...cityFilterOptions.map((city) => {
                return {
                  label: city,
                  value: slugify(city),
                };
              }),
            ]}
            value={slugify(currentFilterCity || '')}
            handleOnChange={(option) => {
              const urlParams = getProjectOverviewUrlParams({
                city: option.value,
                cityFilterOptions: cityFilterOptions,
                region: currentFilterRegion,
                regionFilterOptions: regionsFilterOptions,
              });

              trackCustomWizard({
                wizardName: 'Filter',
                wizardStep: 1,
                actionType: 'select_filter',
                action: 'submit',
                actionDetail: 'Filter op plaats',
                wizardOutput: option?.label,
              });

              setParamsToRoute(urlParams);
            }}
          />
        </Box>
      ) : null}
    </Stack>
  );
};
